
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        color: {
            type: String as PropType<'gray' | 'green' | 'royal-blue' | 'purple' | 'red' | 'orange'>,
            default: 'gray'
        }
    }
})
